// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import Logo from "./assets/league-logo.png";
var TEMPLATE_MODULE_ASSETS_MAP = {
  LOGO: Logo
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(TEMPLATE_MODULE_ASSETS_MAP);
};

// src/constants/feature-flags.ts
var CARE_TEAM = "care_team";

// src/index.ts
initModule();
export {
  CARE_TEAM
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/care-team'] = window.leagueSDKsPresent['@leagueplatform/care-team'] || [];
    window.leagueSDKsPresent['@leagueplatform/care-team'].push('2.25.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/care-team'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/care-team module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map